import Vue from 'vue'
import i18n from '@/locales/_i18n';

const getDefaultState = () => {
    return {
        campanhaSazonal: {
            id: 0,
            descricao: "",
            desconto: 0
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$spTechApi.get("campanha/sazonal/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listCampanha = result.data.result;

                return listCampanha;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar campanhas sazonais: [${ex}]`
            };
        }
    },

    async ConsultarParticipacao(_, idDistribuidor) {

        try {
            const result = await Vue.prototype.$spTechApi.get(`campanha/sazonal/consultar-participacao-por-id/${idDistribuidor}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listCampanha = result.data.result;

                return listCampanha;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar campanhas sazonais: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.get(`campanha/sazonal/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Erro ao obter campanha sazonal`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Erro ao obter campanha sazonal: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, campanhaSazonalRequest) {

        try {
            const result = await Vue.prototype.$spTechApi.post(`campanha/sazonal/create-update`, campanhaSazonalRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let msg = "Registro atualizado com sucesso!";

                if (campanhaSazonalRequest.id === 0) {
                    msg = "Registro criado com sucesso!";
                }

                return {
                    success: true,
                    msg: msg
                };
            }
            else {
                return {
                    success: false,
                    msg: `${i18n.t('erroCriarAtualizarRegistro')}`
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    msg: `${i18n.t('erroCriarAtualizarRegistro')}: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    msg: `${i18n.t('erroCriarAtualizarRegistro')}: [${error}]`
                };
            }
        }
    },

    async Delete(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.delete(`campanha/sazonal/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                return {
                    success: true,
                    msg: "Registro excluído com sucesso!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    msg: `Erro ao excluir registro: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    msg: `Erro ao excluir registro: [${error}]`
                };
            }
        }
    },

    async Ativar(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.put(`campanha/sazonal/ativar/${id}`,
            {},
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return {
                    success: true,
                    msg: "Campanha ativada com sucesso!"
                };
            }
            else {
                return {
                    success: false,
                    msg: "Erro ao ativar a campanha!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                msg: `Erro ao ativar a campanha: [${ex}]`
            };
        }
    },

    async Inativar(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.put(`campanha/sazonal/inativar/${id}`,
            {},
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return {
                    success: true,
                    msg: "Campanha inativada com sucesso!"
                };
            }
            else {
                return {
                    success: false,
                    msg: "Erro ao inativar a campanha!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                msg: `Erro ao inativar a campanha: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.campanhaSazonal, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.campanhaSazonal;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
